// The file endpoint deliberately serves unknown formats as binary downloads.
// Known text files can still be read as inert React text by the attachment viewer.
export async function attachmentText(blob, filename = '', contentType = '') {
  const name = (filename || '').toLowerCase();
  const isJson = name.endsWith('.json') || contentType.includes('application/json');
  if (!isJson && !/\.(txt|csv)$/.test(name) && !contentType.startsWith('text/plain')) return null;
  const text = await blob.text();
  if (isJson) {
    try { return JSON.stringify(JSON.parse(text), null, 2); } catch (_) { /* Show malformed JSON as inert text. */ }
  }
  return text;
}

export function hasParsedAttachment(file) {
  return file.source === 'inbound_email_body' || /\.json$/i.test(file.name || file.filename || '');
}
export function attachmentLabel(file) {
  return hasParsedAttachment(file) ? 'Original email / document' : (file.name || file.filename);
}
